import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import printer from './utils/printer'
import davinci_printer from "~/utils/davinci_printer";
import ks_printer from "~/utils/ksPrinter";
import pddPrinter from "~/utils/pddPrinter";
import SkuSelection from '~/components/SkuSelection'
import NewSkuSelection from '~/components/NewSkuSelection'
import NewSysPage from '~/components/NewSysPage'
import AfterSaleOrderSyncBtn from '~/components/AfterSaleOrderSyncBtn'
import EmployeeSelector from '~/components/EmployeeSelector'
import channelPrinter from "~/utils/channelPrinter";
import xhsPrinter from "~/utils/xhsPrinter";
import xhsPrinterV2 from "~/utils/xhsPrinterV2";

Vue.use(ElementUI)
Vue.component('skuSelection', SkuSelection)
Vue.component('newSkuSelection', NewSkuSelection)
Vue.component('newSysPage', NewSysPage)
Vue.component('afterSaleOrderSyncBtn', AfterSaleOrderSyncBtn)
Vue.component('employeeSelector', EmployeeSelector)

new Vue({
  el: '#app',
  render: h => h(App)
})

// 建立菜鸟打印机的Socket链接
printer.doConnect()
// 建立抖店打印机的Socket链接
davinci_printer.doConnect()
ks_printer.doConnect()
pddPrinter.doConnect()
channelPrinter.doConnect()
xhsPrinter.doConnect()
xhsPrinterV2.doConnect()



// WEBPACK FOOTER //
// ./src/main.js